import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSingleStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.24483 17.7325L13.6014 13.5987L17.7325 2.24483C17.8273 1.98474 17.9997 1.76007 18.2265 1.60132C18.4532 1.44257 18.7233 1.35742 19.0001 1.35742C19.2769 1.35742 19.547 1.44257 19.7738 1.60132C20.0005 1.76007 20.173 1.98474 20.2677 2.24483L24.4015 13.6014L35.7581 17.7325C36.0182 17.8273 36.2429 17.9997 36.4016 18.2265C36.5604 18.4532 36.6455 18.7233 36.6455 19.0001C36.6455 19.2769 36.5604 19.547 36.4016 19.7738C36.2429 20.0005 36.0182 20.173 35.7581 20.2677L24.3988 24.4015L20.2677 35.7581C20.173 36.0182 20.0005 36.2429 19.7738 36.4016C19.547 36.5604 19.2769 36.6455 19.0001 36.6455C18.7233 36.6455 18.4532 36.5604 18.2265 36.4016C17.9997 36.2429 17.8273 36.0182 17.7325 35.7581L13.5987 24.3988L2.24483 20.2677C1.98474 20.173 1.76007 20.0005 1.60132 19.7738C1.44257 19.547 1.35742 19.2769 1.35742 19.0001C1.35742 18.7233 1.44257 18.4532 1.60132 18.2265C1.76007 17.9997 1.98474 17.8273 2.24483 17.7325Z",
		stroke: "currentColor",
		strokeWidth: 1.71429,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSingleStar;
